import opCoMock from "@/mock/operation-commercial.json";
import {operationCommercial} from "@/types/operationCommercial";

import {getDataMock} from "./_callApi";

export async function getOperationCommercial(): Promise<operationCommercial[]> {
  if (getDataMock()) {
    const operatioin: operationCommercial[] = opCoMock;
    return operatioin;
  } else {
    const operatioin: operationCommercial[] = opCoMock;
    return operatioin;
  }
}
